<template>
  <v-container>
    <v-layout text-xs-center wrap class="justify-center" v-if="product">
      <v-flex mb-2 xs12>
        <h1>구매하기(계좌이체)</h1>
      </v-flex>
      <v-flex mb-2 xs12>
        <b style="font-size: 1.5em">
          {{ product.name }}
        </b>
      </v-flex>

      <v-flex mb-2 xs12>
        {{ product.description }}
      </v-flex>
      <v-flex mb-2 xs12 text-xs-left> </v-flex>
      <v-flex mb-2 xs12 text-xs-left>
        <b>Payment Information:</b>
        <br /><b>입금마감:</b> {{ product.pay_by_text }} <br /><b
          >입금액 Amount:</b
        >
        {{ product.currency }} {{ product.price.toLocaleString() }}원
        <br />
        <br />
        <div v-html="sales_channel.payment_html"></div>
        <br />
        <br />Price is only valid after order confirmation. In case product is
        no longer available, you will be placed into a waiting list <br />신청
        후 확인 화면에서 본인의 신청 순서를 확인하시고 정원에 속하신 분만 입금을
        하시기 바랍니다. <br />본인의 신청 순서가 정원을 초과한 경우 대기그룹이
        됩니다. 이 경우 입금 하지 마시기 바랍니다.
      </v-flex>

      <v-flex mb-2 xs12 v-if="product.immediate_sale">
        <v-btn :disabled="disable_button" @click="confirm" color="info"
          >구매확정 / Submit Order</v-btn
        >
      </v-flex>

      <v-alert :value="message" type="info">
        <b v-html="message"></b>
      </v-alert>

      <br />
      <br />
      <v-btn
        :to="`/events/${this.$route.params.event_id}/products/${product.id}`"
      >
        상품 상세 See Details
      </v-btn>
    </v-layout>
    <v-layout text-xs-center wrap class="justify-center" v-else>
      Loading product...
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import {fetcher} from '@/fetcher.js';

export default {
  data: () => ({disable_button: false, message: ''}),
  beforeMount: async function() {
    this.$store.dispatch('loadEventSalesChannels', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadEventProducts', {
      event_id: this.$route.params.event_id,
    });
    this.$data.event_id = this.$route.params.event_id;
  },
  computed: {
    ...mapState(['event_products', 'event_sales_channels']),
    product() {
      return this.event_products?.find(x => {
        return x.id == this.$route.params.product_id;
      });
    },
    sales_channel() {
      // console.log('EP-SKR', 'comp sales_channel', this.event_sales_channels);
      return this.event_sales_channels?.find(x => {
        return x.id == this.$route.params.sales_channel_id; // Could be more than one krbank grrrrrrr
      });
    },
  },
  methods: {
    confirm: async function() {
      if (!this.sales_channel) {
        return;
      }
      if (this.disable_button) {
        return; // In case browser ignores disable_button directive
      }

      try {
        this.disable_button = true;
        let resp = await fetcher.post('/myprofile/event_product_purchase', {
          sales_channel_id: this.sales_channel.id,
          product_ids: [this.$route.params.product_id],
          event_id: this.$route.params.event_id,
        });

        if (resp.data.success) {
          console.log('event_product_purchase', resp);
          this.$router.push(
            `/events/${this.$route.params.event_id}/orders/${resp.data.order.id}`,
          );
        } else {
          if (resp.data.available_in) {
            let ai = resp.data.available_in;
            var en_in;
            var ko_in;

            // For people who have a low IQ
            if (ai.dd > 0) {
              en_in = `${ai.dd} days, ${ai.hh} hours, ${ai.mm} minutes, ${ai.ss} seconds`;
              ko_in = `${ai.dd}일 ${ai.hh}시간 ${ai.mm}분 ${ai.ss}초`;
            } else if (ai.hh) {
              en_in = `${ai.hh} hours, ${ai.mm} minutes, ${ai.ss} seconds`;
              ko_in = `${ai.hh}시간 ${ai.mm}분 ${ai.ss}초`;
            } else if (ai.mm) {
              en_in = `${ai.mm} minutes, ${ai.ss} seconds`;
              ko_in = `${ai.mm}분 ${ai.ss}초`;
            } else {
              en_in = `${ai.ss} seconds`;
              ko_in = `${ai.ss}초`;
            }

            this.message = `
            Product Available In: <br/>${en_in}
            <br/>
            <br/>
            아직 신청이 시작되지 않았습니다. 
            <br/>
            페이지를 리프레시 하지 마시고 
            <br/>
            ${ko_in}
            <br/>후에 다시 신청 버튼을 클릭해주세요. 
            <br/>페이지를 자꾸 리프레시 하시면 로딩 시간 때문에 신청 순번에서 밀릴 수 있습니다.
            `;
          } else {
            this.message = resp.data.message;
          }
        }
      } catch {
        this.message = 'Network error';
      } finally {
        setTimeout(() => {
          this.disable_button = false;
        }, 400);
      }
    },
  },
};
</script>

<style></style>
